import { datadogRum } from '@datadog/browser-rum';
import { UserImpersonation } from 'web-shared/services/user-impersonation';
import { User } from '../../types/User.types';

export const setUser = (user: User) => {
  if (user && process.env.DATADOG_APP_ID) {
    const originalUserId = UserImpersonation.getImpersonationData()?.originalUserId;

    datadogRum.setUser({
      id: user.id.toString(),
      email: user.email,
      name: `${user.first_name} ${user.last_name}`,
      ...(originalUserId && {
        impersonated: true,
        original_user_id: originalUserId,
      }),
    });
  }
};

export const removeUser = () => {
  if (process.env.DATADOG_APP_ID) {
    datadogRum.clearUser();
  }
};